import React, { useState, useEffect } from 'react';
import { useDevice } from '../context/DeviceContext';
import { LoadingDisplay } from './utils';
import { HotspotSettingsTab } from './HotspotSettingsTab';
import { ModifyAutoConfigTab } from './ModifyAutoConfigTab';

export const DeviceSettingsPage = () => {
    const { device, api } = useDevice();
    const [provisionStatus, setProvisionStatus] = useState({ isLoading: true, isProvisioned: false });

    useEffect(() => {
        if (!device?.id) return;
        
        setProvisionStatus({ isLoading: true, isProvisioned: false });
        api.getProvisionStatus(device.id)
            .then(status => {
                setProvisionStatus({ isLoading: false, isProvisioned: status.isAutoProvisioned });
            })
            .catch(() => {
                setProvisionStatus({ isLoading: false, isProvisioned: false });
            });
    }, [device, api]);

    if (provisionStatus.isLoading) {
        return <LoadingDisplay message="Checking device configuration..." />;
    }

    return provisionStatus.isProvisioned 
        ? <ModifyAutoConfigTab /> 
        : <HotspotSettingsTab />;
};